
/* injects from baggage-loader */

'use strict';

const indexOf = [].indexOf || function (item) {
  for (let i = 0, l = this.length; i < l; i++) {
    if (i in this && this[i] === item) {
      return i;
    }
  }
  return -1;
};

const moduleBlockDropOverlays = angular.module('services.layoutEditor.blockDropOverlays', ['services.editorNamespace']);

moduleBlockDropOverlays.factory('blockDropOverlays', [
  '$timeout', '$injector', 'ns', 'blocksBuilder', '$rootScope', 'TimeMachine',
  ($timeout, $injector, ns, blocksBuilder, $rootScope, TimeMachine) => {
    let Y;

    const blockDropOverlays = {
      init: function(y) {
        Y = y;
      },
      widgetsWithoutOverlay: ['spacer'],
      destroyOverlays: function() {
        const layoutEditor = $injector.get('layoutEditor');

        layoutEditor.layout.all(ns.blockDropOverlay).remove();
      },
      addOverlaysToBlocks: function(drag, event = false) {
        let dragNode;

        if (event) {
          dragNode = event.currentTarget;
        } else {
          dragNode = drag.target.get('node');
        }

        const self = this;

        if (!blocksBuilder.isFloating(dragNode)) {
          const layoutEditor = $injector.get('layoutEditor');
          const newOverlay = Y.DOM.create('<div class=\'' + (ns.blockDropOverlay.substr(1)) + '\'></div>');
          const blocks = layoutEditor.layout.all(ns.blockClass);

          blocks.each(function(block) {
            const ref = block.widget.type;
            if (block.widget && indexOf.call(self.widgetsWithoutOverlay, ref) < 0) {
              block.append(newOverlay);
            }
          });

          const ref = dragNode.widget.type;
          if (indexOf.call(self.widgetsWithoutOverlay, ref) < 0) {
            dragNode.append(newOverlay);
          }
        }
      },
      createOverlays: function(drag, event = false) {
        const self = this;

        if (event) {
          this.target = event.currentTarget.one(ns.widgetWrapperClass);
        } else {
          this.target = drag.target.get('node').one(ns.widgetWrapperClass);
        }

        if ($rootScope.widgetIsEditing) {
          return false;
        }

        this.addOverlaysToBlocks(drag, event);

        const layoutEditor = $injector.get('layoutEditor');
        const overlays = layoutEditor.layout.all(ns.blockDropOverlay);

        overlays.each(function(overlay) {
          const block = overlay.ancestor(ns.blockClass);
          const ref = block.widget.type;

          if (block.widget && (indexOf.call(self.widgetsWithoutOverlay, ref) < 0)) {
            overlay.setAttrs({
              'offsetWidth': block.get('offsetWidth'),
              'offsetHeight': block.get('offsetHeight')
            });
            const drop = new Y.DD.Drop({
              node: overlay
            });
          }
        });
      },
      getTarget: function(event) {
        return event.currentTarget.one(ns.widgetWrapperClass);
      },
      isOverlay: function(element) {
        if (angular.isDefined(element.hasClass)) {
          return element.hasClass(ns.blockDropOverlay.substr(1));
        }
      }
    };
    return blockDropOverlays;
  }
]);



// WEBPACK FOOTER //
// ./src/app/editor/services/layout_editor/blockDropOverlays.js